import IconoInstagram from './IconoInstagram';
import { marca, navegacion, contacto } from '../data/contenido';

export default function Nav() {
  return (
    <nav className="nav" aria-label="Navegación principal">
      <a className="nav__marca" href="#inicio">
        {marca.nombre}
      </a>

      <ul className="nav__enlaces">
        {navegacion.map((item) => (
          <li key={item.id}>
            <a href={`#${item.id}`}>{item.etiqueta}</a>
          </li>
        ))}
      </ul>

      <a className="nav__contacto" href={contacto.instagramUrl} target="_blank" rel="noreferrer">
        Instagram
        <IconoInstagram />
      </a>
    </nav>
  );
}
